import { createContext } from 'react';

import type { SessionView } from '@/shared/api/types';

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous';

export interface AuthContextValue {
  status: AuthStatus;
  session: SessionView | null;
  signIn: (email: string, password: string, tenantSlug?: string) => Promise<void>;
  signOut: () => Promise<void>;
  /**
   * Abre sessao em outra empresa da mesma identidade.
   *
   * Quem decide e o servidor: ele confere o vinculo, abre outra sessao e encerra a
   * anterior. Trocar de empresa nao e filtrar a tela.
   */
  switchTenant: (tenantSlug: string) => Promise<void>;
  /**
   * Troca a corretora pela qual o assessor atua (P-ACE-2). So existe para quem entrou
   * pela assessoria; quem decide e o servidor, que so aceita a corretora da assessoria.
   * Opcional para que as telas montadas sem o provedor completo continuem valendo.
   */
  switchBroker?: (brokerId: string) => Promise<void>;
  /** Informa se o usuario possui a permissao indicada. */
  can: (permission: string) => boolean;
  /** Informa se a empresa contratou a funcionalidade indicada. */
  hasFeature: (feature: string) => boolean;
}

/**
 * Contexto de sessao.
 *
 * As funcoes `can` e `hasFeature` orientam a interface, e nao substituem a
 * verificacao do servidor. Esconder um botao melhora a experiencia. A decisao de
 * autorizacao continua sendo do backend, a cada requisicao.
 * Ver docs/AUTHORIZATION.md.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);
